<template>
    <div id="layout" v-on:mouseup="mouseUp" v-on:mousemove="mouseMove">
        <div v-show="working > 0" class="lds-facebook"><div></div><div></div><div></div></div>
        <div id="content">
            <div class="side">
                <Menu></Menu>
                <div class="tabs">
                    <button v-bind:class="{active: list_mode === 'sites'}" v-on:click="list_mode='sites'"><star-icon></star-icon>Sites({{sites.length}})</button>
                    <button v-bind:class="{active: list_mode === 'servers'}" v-on:click="list_mode='servers'"><server-icon></server-icon>Servers({{servers.length}})</button>
                    <button v-bind:class="{active: list_mode === 'groups'}" v-on:click="list_mode='groups'"><folder-icon></folder-icon>Groups({{groups.length}})</button>
                    <input v-show="list_mode === 'sites'" type="text" v-model="search_string" class="search" placeholder="search...">
                    <CheckSlider v-model="sites_list_simple" label="simple"></CheckSlider>
                </div>
                <p v-show="list_mode === 'sites' && !sites_list_simple" id="sites_header">
                    <span class="metrika">Visits</span>
                    <span class="metrika">Pageviews</span>
                    <span class="metrika">Users</span>
                    <span class="moz_rank"><a href="#">DA</a>/<a href="#">PA</a></span>
                </p>
                <ul v-if="list_mode === 'sites'" id="sites_list">
                    <site-item v-bind:setGroup="toggleGroup" v-bind:getGroupById="getGroupById" v-bind:selectSite="selectSite" v-for="site in sitesFiltered" v-bind:site="site" v-bind:key="site.id" v-bind:simple="sites_list_simple"></site-item>
                </ul>
                <ul id="groups_list" v-if="list_mode === 'groups'">
                    <group-item v-bind:toggleGroupShow="toggleGroupShow" v-bind:toggleGroup="toggleGroup" v-for="group in groups" v-bind:group="group" v-bind:key="group.id"></group-item>
                </ul>
                <ul id="servers_list" v-if="list_mode === 'servers'">
                    <server-item v-bind:toggleGroupShow="toggleGroupShow" v-bind:toggleGroup="toggleGroup" v-for="server in servers" v-bind:server="server" v-bind:key="server.name"></server-item>
                </ul>
            </div>
            <div class="network" id="network">
            </div>
            <div ref="legend" class="legend" v-on:mousedown="mouseDown" v-on:mousemove="mouseMove" v-on:mouseup="mouseUp">
                <p class="stoned tabs"><button class="toggle" v-bind:class="(legend.map_filter === 'all')?'pressed':''" v-on:click="setMapFilter('all')">all</button><button class="toggle red" v-bind:class="(legend.map_filter == 'index')?'pressed':''" v-on:click="setMapFilter('index')">/</button></p>
                <ul id="legend_groups_list" v-show="legend.show_groups">
                    <group-item v-bind:toggleGroupShow="toggleGroupShow" v-bind:toggleGroup="toggleGroup" v-for="group in groups" v-bind:group="group" v-bind:key="group.id"></group-item>
                </ul>
                <button class="collapse" v-show="legend.show_groups" v-on:click="setShowGroups(false)">&#x25B2;</button><button class="expand" v-show="!legend.show_groups" v-on:click="setShowGroups(true)">&#x25BC;</button>
            </div>
        </div>
        <status-bar v-bind:showLinksList="showLinksList" v-bind:site_info="site_info"></status-bar>
        <links-list ref="linksList" v-if="linksListVisible" v-bind:hide-me="hideLinksList" v-bind:site_info="site_info"></links-list>
    </div>
</template>

<script>
    import Menu from '@/components/small/Menu'
    import SiteItem from '@/components/small/SıteItem'
    import GroupItem from '@/components/small/GroupItem'
    import ServerItem from "@/components/small/ServerItem"
    import StatusBar from '@/components/StatusBar'
    import LinksList from '@/components/LinksList'

    import axios from 'axios'
    import Storages from 'js-storage'

    import config from '@/config'

    import { ServerIcon, FolderIcon, StarIcon } from 'vue-feather-icons'

    export default {
        name: "Main",
        components:{
            ServerItem,
            Menu,
            LinksList,
            StatusBar,
            SiteItem,
            GroupItem,
            ServerIcon,
            FolderIcon,
            StarIcon
        },
        data: function (){
            return {
                legend: {
                    //show on map all links or links from index onlly
                    map_filter: (Storages.localStorage.isSet("Main:legend:map_filter"))? Storages.localStorage.get("Main:legend:map_filter"):"all",
                    show_groups: (Storages.localStorage.isSet("Main:legend:show_groups"))? Storages.localStorage.get("Main:legend:show_groups"):true
                },
                linksListVisible: false,
                graph: {},
                sites: [],
                groups: [],
                servers: [],
                links: [],
                dragging: false,
                working: 0,
                //FIXME: WHAT THE FUCK?!
                mouse_down: false,
                mouse_clicked: false,
                list_mode: (Storages.localStorage.isSet("Main:list_mode"))? Storages.localStorage.get("Main:list_mode"):"sites", //sites, servers or groups
                selected: {},
                network: null,
                site_info: null,
                search_string: (Storages.localStorage.isSet("Main:search_string"))? Storages.localStorage.get("Main:search_string"):"",
                filter: null,
                sites_list_simple: (Storages.localStorage.isSet("Main:sites_list_simple"))? Storages.localStorage.get("Main:sites_list_simple"):false
            }
        },
        watch: {
            list_mode: function (_old, _new) {
                Storages.localStorage.set("Main:list_mode", this.list_mode)
            },
            search_string: function () {
                Storages.localStorage.set("Main:search_string", this.search_string)
            }
        },
        computed: {
            sitesFiltered: function () {
                return this.sites.filter( (site) => {
                   return site.title.toLowerCase().indexOf(this.search_string) > -1
                });
            }
        },
        beforeDestroy: function (){

        },
        mounted: function(){
            this.getGroups();

            let left = this.$refs.legend.getBoundingClientRect().left;
            let top = this.$refs.legend.getBoundingClientRect().top;


            if (Storages.localStorage.isSet("Main:legend-left")){
                left = Storages.localStorage.get("Main:legend-left");
            }
            if (Storages.localStorage.isSet("Main:legend-top")){
                top = Storages.localStorage.get("Main:legend-top");
            }

            this.$refs.legend.style.left = left;
            this.$refs.legend.style.top = top;

            Storages.localStorage.set("Main:legend-left", left);
            Storages.localStorage.set("Main:legend-top", top);
        },
        methods: {
            mouseMove(event){
                if (this.mouse_clicked){
                    let left = this.$refs.legend.getBoundingClientRect().left + event.movementX;
                    let top = this.$refs.legend.getBoundingClientRect().top + event.movementY;

                    this.$refs.legend.style.top = top;
                    this.$refs.legend.style.left = left;

                    Storages.localStorage.set("Main:legend-top", top);
                    Storages.localStorage.set("Main:legend-left", left);

                    event.stopPropagation()
                    return;
                }

                if (this.$refs.linksList){
                    this.$refs.linksList.mouseMove(event);
                }
            },
            mouseUp(event){
                this.mouse_clicked = false;
                if (this.$refs.linksList) {
                    this.$refs.linksList.mouseUp(event);
                }
            },
            mouseDown(event){
                this.mouse_clicked = true;
            },
            //======================================================================================
            setShowGroups(show){
                this.legend.show_groups = show;
                Storages.localStorage.set("Main:legend:show_groups", show);
            },
            setMapFilter(show){
                this.legend.map_filter = show;
                Storages.localStorage.set("Main:legend:map_filter", show);

                this.getGroups();
            },
            //======================================
            showLinksList: function(){
                this.linksListVisible = true;
            },
            hideLinksList: function(){
                this.linksListVisible = false;
            },
            //======================================
            startWork: function(){
                this.working++;
            },
            endWork: function(){
                this.working--;
            },
            //======================================
            getGroups: function(){
                this.startWork();

                axios
                    .get(config.api_url + '/?op=groups')
                    .then(response => {
                        this.groups = [];

                        response.data.forEach(group => {
                            if (Storages.localStorage.isSet('Main:group-selected-' + group.id)) {
                                group.selected = Storages.localStorage.get('Main:group-selected-' + group.id);
                            }else{
                                group.selected = false;
                            }
                            if (Storages.localStorage.isSet('Main:group-show-' + group.id)) {
                                group.show = Storages.localStorage.get('Main:group-show-' + group.id);
                            }else{
                                group.show = true;
                            }

                            this.groups.push(group);
                        });

                    })
                    .finally((()=>{
                        this.getServers();
                        this.endWork();
                    }))
            },
            getServers: function(){
                this.startWork();

                axios
                    .get(config.api_url + '/?op=servers')
                    .then(response => {
                        this.servers = [];

                        response.data.forEach(server => {
                            if (Storages.localStorage.isSet('Main:server-selected-' + server.name)) {
                                server.selected = Storages.localStorage.get('Main:server-selected-' + server.name);
                            }else{
                                server.selected = false;
                            }
                            if (Storages.localStorage.isSet('server-show-' + server.name)) {
                                server.show = Storages.localStorage.get('server-show-' + server.name);
                            }else{
                                server.show = true;
                            }

                            this.servers.push(server);
                        });
                    })
                    .finally(() => {
                        this.refreshData();
                        this.endWork()
                    })
            },
            refreshData: function() {
                let request_url = config.api_url + '/?op=map';

                if (this.legend.map_filter !== 'all'){
                    request_url = request_url + "&index_only";
                }

                this.startWork();

                axios
                    .get(request_url)
                    .then(response => {
                        this.sites = response.data.nodes;
                        this.sites.sort(sort_by('title', false));
                        this.links = response.data.links;
                        this.drawNetwork();
                        this.endWork();
                    })
                .catch(error => console.log(error))
            },
            getSiteInfo: function (){

                this.site_info = null

                this.network.refresh()

                this.startWork()

                axios
                    .get(config.api_url + '/?op=sites&cmd=show&url='+this.selected.url+'&type='+this.selected.site_type)
                    .then(response => {
                        this.site_info = response.data;
                        this.network.refresh()
                        this.endWork();
                    })
                    .catch(error => console.log(error))
            },
            //==============================================
            nodeSize: function (node){
                if (node.selected){
                    return 20;
                }
                if (node.site_type == 'site'){
                    return 15;
                }

                if (node.site_type == 'satt'){
                    return 12;
                }

                return 9;
            },
            nodeColor: function(node){
                // if (node.selected){
                //     return "#712bc2";
                // }
                if (node.group != null){
                    if (node.selected){
                        return node.group.color;
                    }else{
                        return hexToRGB(node.group.color, 0.4);
                    }
                }

                if (node.site_type == 'site'){
                    return "#E99";
                }

                if (node.site_type == 'satt'){
                    return "#7bcaca";
                }

                return "#666";
            },
            edgeColor: function (edge){
                if (edge.plus){
                    return "#0C0";
                }
                if (edge.minus){
                    return "#C00";
                }

                let node = this.getSiteById(edge.source);
                if (node.group != null){
                    if (edge.selected){
                        return node.group.color;
                    }else{
                        return hexToRGB(node.group.color, 0.5);
                    }
                }

                return this.getSiteById(edge.source).color;
            },
            edgeSize: function (edge){
                if (edge.selected){
                    return 2;
                }
                return 1;
            },
            nodeIcon: function (node){
                if (node.site_type === 'site'){
                    return "/img/globe.png";
                }

                if (node.site_type === 'satt'){
                    return "/img/moon.png";
                }

                if (node.site_type === 'land'){
                    return "/img/mars.png";
                }

                return '/img/asteroid.png';
            },
            //===================================
            getSiteById: function(id){
                let mysite = null;
                this.sites.forEach( function ( value ){
                    if (value.id === id){
                        mysite = value;
                        return;
                    };
                });

                return mysite;
            },
            getGroupById: function(id){
                let mygroup = null;
                this.groups.forEach( function ( value){
                    if (value.id === id){
                        mygroup = value;
                        return;
                    };
                });

                return mygroup;
            },
            selectSite: function (site){
                if (site === this.selected){return;}
                if (!site){return;}

                this.sites.forEach( function(value) {
                    value.selected = false;
                });

                this.selected = site;
                site.selected = true;

                //this.network.graph.nodes(site.id).selected = true;

                // this.network.graph.edges().forEach(function (value) {
                //     value.selected = (value.source == site.id) || (value.target == site.id);
                //     app.network.refresh();
                // });

                /*$.each(this.network.graph.adjacentEdges(site.id), function (key, value) {
                    value.color = "#F00";
                });*/

                console.log("info");

                this.getSiteInfo();

                this.redrawNetwork();

                //this.network.refresh();
                //this.network.selectNodes([site.id]);
            },
            resetSelection: function (){
                this.sites.forEach( function(value) {
                    value.selected = false;
                });

                this.selected = null

                this.site_info = null

                this.redrawNetwork();
            },
            toggleGroupShow: function (group){
                group.show = !group.show;

                Storages.localStorage.set('Main:group-show-' + group.id, group.show);
                this.redrawNetwork();
            },
            toggleGroup: function (group){
                group.selected = !group.selected;

                Storages.localStorage.set('Main:group-selected-' + group.id, group.selected);

                let highlight = [];

                this.network.graph.nodes().forEach( value => {
                    if ((value.group != null) && (value.group.selected)){
                        highlight.push(value.id);
                        value.selected = true;
                    }else if (this.selected.id !== value.id){
                        value.selected = false;
                    }
                });

                this.network.graph.edges().forEach( function (value){
                    if (highlight.indexOf(value.source) != -1 || highlight.indexOf(value.target) != -1){
                        value.selected = true;
                    }else{
                        value.selected = false;
                    }
                });

                this.redrawNetwork();
            },
            redrawNetwork: function (){
                let highlight = [];

                this.sites.forEach( value => {
                    if ((value.group !== null) && (value.group.selected)){
                        highlight.push(value.id);
                        value.selected = true;
                    }else{
                        if (this.selected && this.selected.id === value.id) {
                                highlight.push(value.id);
                                value.selected = true;
                        }else{
                            value.selected = false;
                        }
                    }

                    value.size = this.nodeSize(value);
                    value.color = this.nodeColor(value);
                    value.image_url = this.nodeIcon(value);
                    value.size = this.nodeSize(value);
                });

                if (this.selected) {
                    this.selected.selected = true;
                    highlight.push(this.selected.id);
                }

                this.links.forEach((value) => {
                    if (highlight.indexOf(value.source) !== -1 || highlight.indexOf(value.target) !== -1){
                        value.selected = true;
                    }else{
                        value.selected = false;
                    }

                    value.color = this.edgeColor(value);
                    value.size = this.edgeSize(value);
                });

                console.log("refreshing.....");

                this.network.refresh();
            },
            drawNetwork: function (){
                console.log("drawing.........");

                this.sites.forEach(value => {
                    if (value.minus == null){
                        value.minus = false;
                    }

                    if (value.plus == null){
                        value.plus  = false;
                    }

                    if (value.selected == null){
                        value.selected  = false;
                    }

                    let coords = {x:0,y:0};

                    if (Storages.localStorage.isSet(value.id)){
                        coords = Storages.localStorage.get(value.id);
                    }else{
                        coords.x = Math.random()*300+1;
                        coords.y = Math.random()*300+1;
                    }

                    value.x = coords.x;
                    value.y = coords.y;
                    value.border = 5;
                    value.type = 'image';
                    if (value.group != null)
                        value.group = this.getGroupById(value.group.id);
                    value.color = this.nodeColor(value);
                    value.image_url = this.nodeIcon(value);
                    value.size = this.nodeSize(value);
                });

                this.links.forEach( (value, key) => {
                    if (value.minus == null){
                        value.minus = false;
                    }

                    if (value.plus == null){
                        value.plus  = false;
                    }

                    if (value.selected == null){
                        value.selected  = false;
                    }

                    value.id = value.source + '-' + value.target + '-' + value.anchor + key;

                    value.type = 'arrow';

                    value.arrow = 'source';

                    value.label = value.anchor;

                    value.color = this.edgeColor(value);
                    value.size = this.edgeSize(value);
                });

                if (this.network == null) {
                    this.network = new sigma({
                        graph: {nodes: this.sites, edges: this.links, clone: false},
                        renderer: {
                            container: "network",
                            type: "canvas"
                        },
                        settings:
                            {
                                skipErrors: false,
                                labelThreshold: 0,
                                drawEdgeLabels: false,
                                drawLabels: false,
                                minArrowSize: 5,
                                hideEdgesOnMove: true,
                                edgeHoverExtremities: false,
                                scalingMode: 'inside',
                                autoRescale: false,
                                animationsTime: 10,
                                enableHovering: false,
                                enableEdgeHovering: false,
                                edgeHoverColor: '#2ecc71',
                                defaultEdgeHoverColor: '#2ecc71',
                                defaultLabelSize: 30,
                                zoomingRatio: 1.1,
                                doubleClickEnabled: false,
                                sideMargin: 40,
                                zoomMin: 0.5,
                                zoomMax: 3,
                                clone: false
                            }
                    });

                    this.filter = sigma.plugins.filter(this.network);

                    this.network.bind("clickNode", (event) => {
                        this.selectSite(this.getSiteById(event.data.node.id));
                    });

                    this.network.bind("doubleClickNode", (event) => {
                        this.selectSite(this.getSiteById(event.data.node.id));
                        this.showLinksList();
                    });

                    this.network.bind('overNode', (event) => {
                        this.network.settings('doubleClickEnabled', false);
                    });

                    this.network.bind('outNode', (event) => {
                        this.network.settings('doubleClickEnabled', true);
                    });

                    // Initialize the dragNodes plugin:
                    let dragListener = sigma.plugins.dragNodes(this.network, this.network.renderers[0]);

                    dragListener.bind('dragend', function (event) {
                        let myNode = event.data.node;
                        Storages.localStorage.set(myNode.id, {x: myNode.x, y: myNode.y});
                    });

                    this.network.bind("coordinatesUpdated", (event) => {
                        console.log(event)
                        this.dragging = true;
                    });

                    this.network.renderers[0].bind("mousedown", (event) => {
                        console.log("MOUSEDOWN")
                        this.mouse_down = true;
                    });

                    this.network.bind("mousemove", (event) => {
                        console.log(event)
                        if (this.mouse_down){
                            this.dragging = true;
                        }
                    });

                    // this.network.bind("click", (event) => {
                    //     console.log(event)
                    //     this.resetSelection()
                    // });
                }

                this.redrawNetwork();
                //this.network.refresh();
            }
        }
    }
</script>

<style scoped>
    #sites_header{
        text-shadow: 1px 1px 0 #FFFFFF;
        padding: 0.5rem;
        padding-right: 2rem;
        justify-content: space-between;
        display: flex;
        flex-direction: row;
        background: linear-gradient(to top, #ffaf03, #ffc21d);
        border-top: 1px solid #FFFFFF;
        border-bottom: 1px solid #000000;
        border-right: 2px solid #ffdb83;
        border-left: 2px solid #6e4600;
    }

    #sites_header .metrika{
        display: inline-block;
        flex: 1.5;
    }

    #sites_header .moz_rank{
        display: inline-block;
        flex: 1;
        text-align: right;
    }

    .slide-down-enter-active {
        animation: slide-down .5s;
    }
    .slide-down-enter-active-to {
        visibility: visible;;
    }
    .slide-down-leave-active {
        animation: slide-down .5s reverse;
    }
    @keyframes slide-down {
        0% {
            opacity: 0;
            height: 0px;
        }
        100% {
            opacity: 1.0;
            height: 200px;
        }
    }

    #network{
        background-color: #000000;
    }

    .legend{
        text-shadow: 1px 1px 0px #FFF;
        background-color: #CCCCCC;
        position: absolute;
        top: 10rem;
        right: 1rem;
        width: 10rem;
        z-index: 1000000000;
        display: inline-block;
        padding: 0;
        border-radius: 0.4rem;
        border-right: 1px solid #ffffff;
        border-top: 2px solid #ffffff;
        border-left: 2px solid #323232;
        border-bottom: 2px solid #323232;
    }

    .legend button.toggle{
        border-radius: 0 0 0.3rem 0.3rem;
        background: #5cb85c;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        border-bottom: 1px solid #1f401f;
        border-left: 1px solid #1f401f;
        border-radius: 0.3rem;
        padding: 0.3rem;
        background: linear-gradient(to bottom, #5cb85c, #468b46);
    }

    .legend button.toggle.pressed{
        border-bottom: 1px solid #ffffff;
        border-left: 1px solid #ffffff;
        border-top: 1px solid #1f401f;
        border-right: 1px solid #1f401f;
        box-shadow: inset -1px 2px 1px #35324e;
    }

    .legend button.red{
        background: #ff6669;
        border-top: 1px solid #ffffff;
        border-bottom: 1px solid #843839;
        border-left: 1px solid #843839;
        background: linear-gradient(to bottom, #ff6669, #ff8b8e);
    }

    .legend p{
        padding: 0.2rem;
        border-bottom: 1px solid #333;
    }

    .legend ul{
        overflow: auto;
        margin: 0;
        border-top: 1px solid #ffffff;
        border-bottom: 1px solid #333;
    }

    .legend ul li{
        background: #CCCCCC;
        padding: 0.2rem;
        border: 0rem;
    }

    ul li a{
        color: #ffffff;
    }

    .legend ul li.active{
        border-top: 1px solid #606060;
        border-bottom: 1px solid #EEE;
        background: #ffd093;
        text-shadow: none;
    }

    .legend ul li.active a{
        text-decoration: none;
    }

    .legend .color{
        display: inline-block;
        border: 1px solid #ffffff;
        width: 1rem;
        height: 1rem;
        background-color: #EEEEEE;
        margin-right: 0.2rem;
        box-shadow: 1px 1px 0px #425360;
    }

    .legend .tabs{
        border-radius: 0.4rem 0.4rem 0rem 0rem;
        border: 0;
    }

    .tabs{
        border-top: 1px solid #b2abff;
        border-right: 2px solid #8781c8;
        background: #a7a1ed;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to bottom, #676195, #a7a1ed);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to bottom, #676195, #a7a1ed); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        padding: 0.5rem;
        color: #FFF;
        border-bottom: 2px solid #35324e;
        border-left: 2px solid #35324e;
        text-shadow: 1px 1px 0px #35324e;
        display: flex;
        flex-wrap: wrap;
    }

    .side{
        border-right: 0;
    }

    .side ul li:hover{
        background: linear-gradient(to bottom, #cfc6cc, #ede9ed);
    }

    .tabs button, .side-title button{
        outline: none;
        background-color: #EEE;
        border: none;
        color: #35324e;
        cursor: pointer;
        box-shadow: -1px 2px 1px #35324e;
        flex: 1;
        margin: 0.3rem 0 0.3rem 0;
        padding: 0.5rem;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        z-index: 100;
        position: relative;
    }

    .tabs button:first-of-type{
        z-index: 10;
        border-radius: 0.3rem 0 0 0.3rem;
        margin-left: 0.3rem;
    }

    .tabs button:last-of-type{
        z-index: 1000;
        border-radius:  0 0.3rem 0.3rem 0;
        margin-right: 0.3rem;
    }

    .tabs .search{
        background-color: #EEE;
        flex: 1 100%;
        border-radius: 0.3rem;
        margin: 0.5rem 0;
        border-top: 2px solid #35324e;
        border-left: 1px solid #ffffff;
        border-bottom: 1px solid #ffffff;
        border-right: 1px solid #35324e;
        padding: 0.5rem 0.2rem;
    }

    #sites_list{
        overflow-y: scroll;
        height: auto;
        border-right: 2px solid #CCCCCC;
    }

    #sites_list li{
        border-left: 2px solid #425360;
        background-clip: border-box;
        overflow: hidden;
    }

    .tabs button svg{
        width: 24px;
        height: 24px;
        margin: 0 0.2rem;
        vertical-align: middle;
        filter: drop-shadow(0 0 0 #333);
    }

    .tabs button.active svg {
        color: #ffef2c;
        filter: drop-shadow(0 0 0.1rem #333);
        transition: 0.3s;
    }

    .tabs button{}

    .tabs button.active{
        font-weight: normal;
        color: #ffffff;
        text-shadow: -1px 1px 1px #949494;
        box-shadow: none;
        background: #CCCCCC;  /* fallback for old browsers */
        border-top: 2px solid #35324e;
        border-left: 1px solid #ffffff;
        border-bottom: 1px solid #ffffff;
        border-right: 1px solid #35324e;
    }
</style>
